import { observer } from "mobx-react-lite";
import * as React from "react";
import styled, { css } from "styled-components";
import { Box } from "src/components/Box";
import { Text } from "src/components/Text";
import { useFilePickerState } from "../states";
import { useTranslation } from "src/hooks";

const ImagePreviewWrapperEl = styled(Box)`
  height: inherit;
  max-width: 300px;
  z-index: 1;

  ${(props) =>
    props &&
    css`
      padding: calc(
          ${props.theme.dimension.spacing.l}px +
            ${props.theme.dimension.spacing.xs}px
        )
        calc(
          ${props.theme.dimension.spacing.l}px * 2 +
            ${props.theme.dimension.spacing.xs}px
        );
    `}
`;

const ImageWrapperEl = styled(Box)`
  ${(props) =>
    props &&
    css`
      margin-bottom: ${props.theme.dimension.spacing.s}px;
      height: calc(
        100% - ${props.theme.layout.margin.xl}px -
          ${props.theme.layout.margin.xxl}px
      );
      box-shadow: 0 2px 4px 0 ${props.theme.colors.background.shadow};
    `}

  & object,
  embed {
    max-height: 100%;
    max-width: 100%;
    min-height: 100%;
    min-width: 100%;
  }
`;

const ImageCaptionEl = styled(Text)`
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
`;

const ImageActionEl = styled(Text)`
  cursor: pointer;
  text-decoration: underline;
`;

const ImageEl = styled.img`
  height: 100%;
`;

export const FilePickerImagePreview = observer(() => {
  const translate = useTranslation();
  const {
    previewUrl,
    caption,
    deleteFile,
    isPdf,
    fileType,
  } = useFilePickerState();

  const url = new URL(previewUrl, window.location.origin);
  url.searchParams.set("t", new Date().getTime().toString());

  const previewUrlUncached = url.toString();

  return (
    <ImagePreviewWrapperEl flex flexDirectionColumn alignItemsCenter width100>
      <ImageWrapperEl>
        {isPdf ? (
          <embed
            id="asp-file-picker-preview-image"
            src={previewUrl}
            type={fileType}
          />
        ) : (
          <ImageEl
            id="asp-file-picker-preview-image"
            src={previewUrlUncached}
          />
        )}
      </ImageWrapperEl>
      <Box
        flex
        flexDirectionRow
        width100
        alignItemsCenter
        justifyBetween
        marginTopXxl
      >
        <ImageCaptionEl id="asp-file-picker-preview-filename">
          {caption || "File Preview"}
        </ImageCaptionEl>
        <ImageActionEl
          id="asp-file-picker-preview-delete"
          as="a"
          onClick={() => deleteFile()}
        >
          {translate("delete")}
        </ImageActionEl>
      </Box>
    </ImagePreviewWrapperEl>
  );
});
